<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div id="Documents">
    <div class="giga-content_container">
      <template v-if="!isSimulationStepper">
        <documents-filter
          v-on:download="download()"
          :queryConfig="queryConfig"
          @applyFilter="applyFilter($event)"
          @reloadData="applyFilter($event)"
          @applySearch="applySearch($event)"
        >
        </documents-filter>
      </template>

      <!-- <div
          v-if="loading"
          class="giga-pre_loading"
      >
        <b-spinner variant="primary" type="grow" label="Spinning"></b-spinner>
      </div> -->

      <page-loader v-if="loading" :pageHasActions="true"></page-loader>

      <template v-else>
        <!--    TODO: set isSimulation -->
        <add-document-step1
          v-if="isAutoriseAddDoc"
          :fileUploadId="'fileUpload1'"
          :isVIEWER="isVIEWER"
          :replace="false"
          :isSimulation="isSimulation"
          :isToBeCompleted="false"
          :selectDocuments="selectedDocsIds"
        >
        </add-document-step1>

        <div v-if="!loading" class="giga-card_list">
          <documents-actions
            :documents="getDocuments.content"
            :isVIEWER="isVIEWER"
            :selectDocuments="selectedDocsIds"
            :deletedDocument="deletedDocument"
            :isSimulation="isSimulation"
            v-on:download="download()"
            :queryConfig="queryConfig"
            @applyFilter="applyFilter($event)"
            @reloadData="applyFilter($event)"
            @callDocumentsActions="handleCallDocumentsActions"
          >
          </documents-actions>

          <!-- DOCUMENT A COMPLETER -->
          <div v-if="!hideComplete && noDocToBeCompleted" class="giga-card">
            <div>
              <h3 class="giga-card_title">Documents à compléter</h3>
            </div>
            <div class="giga-card_content">
              <table class="giga-table docs-table none-hover">
                <thead>
                  <tr>
                    <th class="giga-checkAll_table">
                      <div
                        class="giga-cutsom_checkbox"
                        :class="classObjectToBeCompleted"
                      >
                        <input
                          type="checkbox"
                          name="checkboxName"
                          v-model="allRowsSelectedToBeCompleted"
                          @change="selectAllRowsToBeCompleted"
                          id=""
                        />
                        <label for="checkboxName"></label>
                      </div>
                    </th>
                    <th class="giga-document_name">Nom du document</th>
                    <th class="giga-document_date">Date de transmission</th>
                    <th class="giga-document_type">Type</th>
                    <th class="giga-document_actions">Opérations</th>
                    <th class="giga-document_actions">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <template
                    v-for="document in $v.getDocuments.content.$each.$iter"
                  >
                    <tr
                      v-if="!document.transmitted.$model"
                      :key="document.id.$model"
                    >
                      <td>
                        <div class="giga-cutsom_checkbox">
                          <input
                            type="checkbox"
                            name="checkboxName"
                            v-model="selectedRowToBeCompleted"
                            :value="document.id.$model"
                            @click="selectDocument(document.id.$model)"
                          />
                          <label for="checkboxName"></label>
                        </div>
                      </td>
                      <td class="giga-document_name">
                        <div class="giga-document_name_label">
                          <i class="extention-icon">
                            <img
                              v-if="
                                getFileExtention(document.name.$model) == 'xlsx'
                              "
                              src="~@/assets/images/extensions/xls.svg"
                            />
                            <img
                              v-else-if="
                                getFileExtention(document.name.$model) == 'txt'
                              "
                              src="~@/assets/images/extensions/txt.svg"
                            />
                            <img
                              v-else-if="
                                getFileExtention(document.name.$model) == 'pdf'
                              "
                              src="~@/assets/images/extensions/pdf.svg"
                            />
                            <img
                              v-else-if="
                                getFileExtention(document.name.$model) == 'docx'
                              "
                              src="~@/assets/images/extensions/doc.svg"
                            />
                            <img
                              v-else-if="
                                getFileExtention(document.name.$model) == 'doc'
                              "
                              src="~@/assets/images/extensions/doc.svg"
                            />
                            <img
                              v-else
                              src="~@/assets/images/extensions/text.svg"
                            />
                          </i>
                          {{ getDocExtention(document.name.$model) }}
                        </div>
                      </td>
                      <td class="giga-document_date">
                        {{
                          moment(document.creationDate.$model, "x").format(
                            "DD/MM/YYYY"
                          )
                        }}
                      </td>
                      <td class="giga-document_type">
                        <multiselect
                          v-select-overflow
                          open-direction="bottom"
                          :searchable="false"
                          :closeOnSelect="false"
                          v-model="document.types.$model"
                          :options="getDocumentsTypes"
                          :placeholder="$t('type_document')"
                          :multiple="false"
                          trackBy="code"
                          label="name"
                          :showLabels="false"
                          class="tags-outline multiselect__type"
                          :isRequired="true"
                          :errorMsg="$t('required_field')"
                          :is-doc-type="true"
                          @input="handleChange(document.id.$model)"
                        >
                          <template slot="caret">
                            <div
                              class="
                                multiselect__select
                                d-flex
                                align-items-center
                                justify-content-center
                              "
                            >
                              <b-icon icon="chevron-down"></b-icon>
                            </div>
                          </template>
                          <template slot="option" slot-scope="props">
                            <div
                              class="
                                option__desc
                                d-flex
                                justify-content-between
                              "
                            >
                              <span class="option__title">{{
                                $t(props.option.name)
                              }}</span>
                              <span
                                class="option__info-icon right"
                                :desc="props.option.info"
                              >
                                <b-icon
                                  class="text-muted"
                                  icon="info-circle"
                                ></b-icon>
                              </span>
                            </div>
                          </template>
                          <template v-slot:selection="{ values }">
                            <span
                              v-for="type in values"
                              :key="type.code"
                              class="multiselect__placeholder"
                            >
                              {{ type.name }}
                            </span>
                          </template>
                        </multiselect>
                      </td>
                      <td class="giga-document_actions">
                        <div
                          class="giga-upload_file_actions"
                          @click="showOperation(document.id.$model)"
                        >
                          <span
                            class="cursor-pointer bg-gray-200 p-2 rounded hover:bg-gray-300 "
                            :class="{
                              'bg-custom':
                                operationClick === document.id.$model &&
                                selectedOperations.get(document.id.$model),
                              'bg-gray-200':
                                operationClick !== document.id.$model
                            }"
                          >
                            <img src="@/assets/images/files.svg" alt="" />
                            {{ getNbrOperations(document.id.$model) }}
                          </span>
                        </div>
                      </td>
                      <td class="giga-document_actions">
                        <span
                          class="material-symbols-outlined menu-icon"
                          @click="toggleMenu(document.id.$model)"
                          >more_vert</span
                        >
                        <div
                          v-if="selectedDocumentId === document.id.$model"
                          class="dropdown-menu"
                        >
                          <button
                            v-if="isUpdatedDocument(document.id.$model)"
                            @click="assignDocument(document.id.$model)"
                            :class="{
                              'no-pointer-events': isTypeDocumentSelected(
                                document.types.$model
                              )
                            }"
                          >
                            Joindre aux opérations
                          </button>
                          <button @click="downloadFile(document.id.$model)">
                            Télécharger
                          </button>
                          <button @click="showDocument(document.id.$model)">
                            Visualiser
                          </button>
                          <button
                            v-if="isDeletedDocument(document.id.$model)"
                            @click="doOpenConfirmModal(document.id.$model)"
                          >
                            Supprimer
                          </button>
                        </div>
                      </td>
                    </tr>

                    <tr
                      :key="document.id.$model"
                      v-if="
                        !document.transmitted.$model &&
                          operationClick === document.id.$model &&
                          selectedOperations.get(document.id.$model)
                      "
                    >
                      <td colspan="6">
                        <OperationList
                          :operations="selectedDocument.operations"
                          :isDeleted="true"
                          :is-selected="false"
                          @operation-deleted-changed.capture="deleteOperation"
                          :document="selectedDocument"
                          class="p-2 pl-5"
                        ></OperationList>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>

          <!-- DOCUMENT TRANSMIS -->
          <div v-if="getDocuments.content.length" class="giga-card">
            <div>
              <h3 class="giga-card_title">Documents transmis</h3>
            </div>
            <div class="giga-card_content">
              <table class="giga-table docs-table none-hover">
                <thead>
                  <tr>
                    <th class="giga-checkAll_table">
                      <div class="giga-cutsom_checkbox" :class="classObject">
                        <input
                          type="checkbox"
                          name="checkboxName"
                          v-model="allRowsSelected"
                          @change="selectAllRows"
                          id=""
                        />
                        <label for="checkboxName"></label>
                      </div>
                    </th>
                    <th class="giga-document_name">Nom du document</th>
                    <th class="giga-document_date">Date de transmission</th>
                    <th class="giga-document_type">Type</th>
                    <th class="giga-document_actions">Opérations</th>
                    <th class="giga-document_actions">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <template
                    v-for="document in $v.getDocuments.content.$each.$iter"
                  >
                    <tr
                      v-if="document.transmitted.$model"
                      :key="document.id.$model"
                      :class="{
                        'giga-active_row': selectedDocsIds.includes(
                          document.id.$model
                        )
                      }"
                    >
                      <td>
                        <div class="giga-cutsom_checkbox">
                          <input
                            type="checkbox"
                            id="checkboxName"
                            name="checkboxName"
                            v-model="selectedRow"
                            :value="document.id.$model"
                            @click="selectDocument(document.id.$model)"
                          />
                          <label for="checkboxName"></label>
                        </div>
                      </td>
                      <td class="giga-document_name">
                        <div class="giga-document_name_label">
                          <i class="extention-icon">
                            <img
                              v-if="
                                getFileExtention(document.name.$model) == 'xlsx'
                              "
                              src="~@/assets/images/extensions/xls.svg"
                            />
                            <img
                              v-else-if="
                                getFileExtention(document.name.$model) == 'txt'
                              "
                              src="~@/assets/images/extensions/txt.svg"
                            />
                            <img
                              v-else-if="
                                getFileExtention(document.name.$model) == 'pdf'
                              "
                              src="~@/assets/images/extensions/pdf.svg"
                            />
                            <img
                              v-else-if="
                                getFileExtention(document.name.$model) == 'docx'
                              "
                              src="~@/assets/images/extensions/doc.svg"
                            />
                            <img
                              v-else-if="
                                getFileExtention(document.name.$model) == 'doc'
                              "
                              src="~@/assets/images/extensions/word.svg"
                            />
                            <img
                              v-else
                              src="~@/assets/images/extensions/text.svg"
                            />
                          </i>
                          {{ getDocExtention(document.name.$model) }}
                        </div>
                      </td>
                      <td class="giga-document_date">
                        {{
                          moment(document.creationDate.$model, "x").format(
                            "DD/MM/YYYY"
                          )
                        }}
                      </td>
                      <td class="giga-document_type">
                        <multiselect
                          v-select-overflow
                          open-direction="bottom"
                          :searchable="false"
                          :isVIEWER="isVIEWER"
                          :closeOnSelect="false"
                          v-model="document.types.$model"
                          :options="getDocumentsTypes"
                          :placeholder="$t('type_document')"
                          :multiple="false"
                          trackBy="code"
                          label="name"
                          :showLabels="false"
                          class="tags-outline multiselect__type"
                          :isRequired="true"
                          :errorMsg="$t('required_field')"
                          :is-doc-type="true"
                          @input="handleChange(document.id.$model)"
                        >
                          <template slot="caret">
                            <div
                              class="
                                multiselect__select
                                d-flex
                                align-items-center
                                justify-content-center
                              "
                            >
                              <b-icon icon="chevron-down"></b-icon>
                            </div>
                          </template>
                          <template slot="option" slot-scope="props">
                            <div
                              class="
                                option__desc
                                d-flex
                                justify-content-between
                              "
                            >
                              <span class="option__title">{{
                                $t(props.option.name)
                              }}</span>
                              <span
                                class="option__info-icon right"
                                :desc="props.option.info"
                              >
                                <b-icon
                                  class="text-muted"
                                  icon="info-circle"
                                ></b-icon>
                              </span>
                            </div>
                          </template>
                          <template v-slot:selection="{ values }">
                            <span
                              v-for="type in values"
                              :key="type.code"
                              class="multiselect__placeholder"
                            >
                              {{ type.name }}
                            </span>
                          </template>
                        </multiselect>
                      </td>
                      <td class="giga-document_actions">
                        <div
                          class="giga-upload_file_actions"
                          @click="showOperation(document.id.$model)"
                        >
                          <span
                            class="cursor-pointer bg-gray-200 p-2 rounded hover:bg-gray-300 "
                            :class="{
                              'bg-custom':
                                operationClick === document.id.$model &&
                                selectedOperations.get(document.id.$model),
                              'bg-gray-200':
                                operationClick !== document.id.$model
                            }"
                          >
                            <img src="@/assets/images/files.svg" alt="" />
                            {{ getNbrOperations(document.id.$model) }}
                          </span>
                        </div>
                      </td>
                      <td class="giga-document_actions">
                        <span
                          class="material-symbols-outlined menu-icon"
                          @click="toggleMenu(document.id.$model)"
                          >more_vert</span
                        >
                        <div
                          v-if="selectedDocumentId === document.id.$model"
                          class="dropdown-menu"
                        >
                          <button
                            v-if="isUpdatedDocument(document.id.$model)"
                            @click="assignDocument(document.id.$model)"
                            :class="{
                              'no-pointer-events': isTypeDocumentSelected(
                                document.types.$model
                              )
                            }"
                          >
                            Joindre aux opérations
                          </button>
                          <button @click="downloadFile(document.id.$model)">
                            Télécharger
                          </button>
                          <button
                            v-if="!isSimulation"
                            @click="replaceFile(document.id.$model)"
                            :disabled="!isReplacedDocument(document.id.$model)"
                            :title="
                              !isReplacedDocument(document.id.$model)
                                ? 'Vous ne pouvez pas remplacer ce document car il est attaché à une opération en cours de vérification ou validée'
                                : ''
                            "
                          >
                            {{ $t("replace") }}
                          </button>
                          <button
                            v-if="!isSimulation"
                            @click="versionFile(document.id.$model)"
                          >
                            Consulter les versions précédentes
                          </button>
                          <button @click="showDocument(document.id.$model)">
                            Visualiser
                          </button>
                          <button
                            v-if="isDeletedDocument(document.id.$model)"
                            @click="doOpenConfirmModal(document.id.$model)"
                          >
                            Supprimer
                          </button>
                        </div>
                      </td>
                    </tr>
                    <tr
                      :key="document.id.$model"
                      v-if="
                        document.transmitted.$model &&
                          operationClick === document.id.$model &&
                          selectedOperations.get(document.id.$model)
                      "
                    >
                      <td colspan="6">
                        <OperationList
                          :operations="selectedDocument.operations"
                          :isDeleted="true"
                          :is-selected="false"
                          :is-simulation="isSimulation"
                          @operation-deleted-changed.capture="deleteOperation"
                          class="p-2 pl-5"
                        ></OperationList>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
            <pagination
              v-if="rows >= perPage"
              :length="length"
              :rows="rows"
              :perPage="perPage"
              :currentPage="currentPage"
              @changePerPage="changePerPage"
              @changeCurrentPage="changeCurrentPage"
            />
          </div>

          <template v-if="!isSimulationStepper">
            <div class="giga-document_footer giga-flex giga-flex_end">
              <div class="giga-button">
                <button
                  class="giga-green_button no-icon"
                  v-if="!isVIEWER"
                  @click="confirmSave"
                  :disabled="isInvalid"
                >
                  <span>{{ $t("save") }}</span>
                </button>
              </div>
            </div>
          </template>
        </div>
      </template>
      <assign-document-operation
        modal-id="assignDocumentOperationDocuments"
        fontSize="h3"
        backdrop-close="false"
        @selectedOperations="handleSelectedOperations"
        :selectedDocument="selectedDocument"
        :selected-operations="selectedDocumentOperations"
        :is-mass-actions="isMassActions"
        :is-simulation="isSimulation"
      ></assign-document-operation>

      <replace-document
        modal-id="replaceDocumentOperationDocuments"
        fontSize="h3"
        backdrop-close="false"
        :is-simulation="isSimulation"
        :selectedDocument="selectedDocument"
      ></replace-document>
      <versions-document
        :selected-document="selectedDocument"
        fontSize="h3"
        backdrop-close="false"
        modal-id="versionsDocument"
      ></versions-document>
    </div>

    <!-- <b-row class="documents" v-if="!loading">

      <b-col cols="12" lg="8" class="mb-4">
        <b-card class="border-raduis-xl border-0 box-shadow-sm p-3">
          
            <documents-list :documents="getDocuments" :selectDocuments="selectedDocsIds" v-on:selectDocument="selectDocument($event)"></documents-list>
        </b-card>
      </b-col>
      <b-col cols="12" lg="4" class="mb-2">
       <documents-details :documents="getDocuments" :selectDocuments="selectedDocsIds"></documents-details>
      </b-col>
    </b-row> -->

    <!-- SAVE CHANGES MODAL -->
    <b-modal
      id="modal-save_changes"
      title="BootstrapVue"
      modal-class="giga-modal giga-actions_modal"
      hide-footer
      hide-header
    >
      <h2 class="giga-modal_title">{{ $t("save_changes") }}</h2>
      <div class="giga-modal_body">
        <p>{{ $t("confirm_save") }}</p>
      </div>
      <div class="giga-modal_footer">
        <div class="giga-button">
          <button
            class="giga-blue_outlined_button no-icon"
            @click="$bvModal.hide('modal-save_changes')"
          >
            {{ $t("dont_save") }}
          </button>
        </div>
        <div class="giga-button">
          <button class="giga-green_button no-icon" @click="saveDocuments">
            {{ $t("save") }}
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="modal-confirm_leave"
      title="BootstrapVue"
      modal-class="giga-modal giga-actions_modal"
      hide-footer
      hide-header
    >
      <h2 class="giga-modal_title">{{ $t("unsaved_changes") }}</h2>
      <div class="giga-modal_body">
        <p>{{ $t("changes_will_be_discarded") }}</p>
      </div>
      <div class="giga-modal_footer">
        <div class="giga-button">
          <button class="giga-red_button no-icon" @click="discardDocuments">
            {{ $t("confirm") }}
          </button>
        </div>
        <div class="giga-button">
          <button
            class="giga-green_button no-icon"
            @click="$bvModal.hide('modal-confirm_leave')"
          >
            {{ $t("stay") }}
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import AddDocumentStep1 from "../../components/static/AddDocument/Step1";
import { mapActions, mapGetters, mapMutations } from "vuex";
import DocumentsActions from "@/components/static/DocumentsActions.vue";
import DocumentsFilter from "@/components/static/DocumentsFilter.vue";
import { find, map, some } from "lodash";
import { documentService } from "../service/document.service";
import eventBus from "@/shared/event.bus";
import { queryConstant } from "@/shared/queryConstant";
import PageLoader from "../../components/static/pageLoader.vue";
import { required } from "vuelidate/lib/validators";
import { helpers } from "@/shared/helper";
import AssignDocumentOperation from "@/components/static/AddDocument/AssignDocumentOperation.vue";
import OperationList from "@/components/static/AddDocument/OperationList.vue";
import { constants } from "@/shared/constants";
import ReplaceDocument from "@/components/static/Document/ReplaceDocument.vue";
import VersionsDocument from "@/components/static/Document/VersionsDocument.vue";
import Pagination from "@/components/static/Pagination.vue";

export default {
  components: {
    Pagination,
    VersionsDocument,
    ReplaceDocument,
    OperationList,
    AssignDocumentOperation,
    AddDocumentStep1,
    DocumentsActions,
    DocumentsFilter,
    PageLoader
  },
  name: "Documents",
  props: ["simulation", "isSimulationStepper"],
  data() {
    const _pageSize_10 = 10;
    const _pageSize_25 = 25;
    const _pageSize_50 = 50;
    return {
      selectedRowToBeCompleted: [],
      allRowsSelectedToBeCompleted: false,
      selectedRow: [],
      allRowsSelected: false,
      toBeCompleted: true,
      hideComplete: "",
      hideTransmitted: "",
      value: document.types,
      selectedDocsIds: [],
      selectedDocs: [],
      checkTypes: "", // TODO: chekcTypes ?
      customFilter: queryConstant.setDefaultCustomFilter(),
      queryConfig: queryConstant.DOCUMENT_CONFIG,
      isSimulation: false,
      search: "",
      selectedDocumentId: null,
      selectedDocument: null,
      selectedDocumentOperations: [],
      selectedOperations: new Map(),
      perPage: _pageSize_10,
      length: [_pageSize_10, _pageSize_25, _pageSize_50],
      currentPage: 1,
      operationClick: null,
      isMassActions: false,
      customOperationFilter: queryConstant.setDefaultCustomFilter(),
      perOperationPage: 20,
      currentOperationPage: 1,
      searchOperation: "",
      allowedStatus: constants.ALLOWED_OPERATIONS_STATUS,
      isOperationsLoading: false
    };
  },
  validations: {
    getDocuments: {
      content: {
        $each: {
          id: {},
          name: {},
          types: { required },
          transmitted: {},
          creationDate: {}
        }
      }
    }
  },
  created() {
    window.addEventListener("beforeunload", this.beforeWindowUnload);
    window.addEventListener("unload", e => this.discardDocuments());
  },
  beforeRouteLeave(to, from, next) {
    if (this.checkDraftDocuments()) {
      this.$root.$emit("bv::show::modal", "modal-confirm_leave");
      this.$root.$on("bv::modal::hidden", () => {
        this.getLeavePage ? next() : next(false);
      });
    } else {
      next();
    }
  },
  mounted() {
    this.isSimulation = this.simulation !== undefined ? this.simulation : false;
    this.setLeavePage(false);
    this.setDocFormInvalid(false);
    this.getAllDocuments();
    this.getDocumentsTypesAction();
    eventBus.$on("reloadDocuments", documentsIds => {
      this.selectedRow = [];
      this.unselectDocs();
      this.getAllDocuments();
      if (documentsIds) {
        this.$root.$emit("bv::hide::modal", "addDocumet");
        eventBus.$emit("setCurrentStep_One");
      }
    });
    eventBus.$on("unselectDocs", () => {
      this.unselectDocs();
    });
    this.getSimulationOperations();
    if (!this.isSimulation) {
      this.fetchAllWorkOperations();
    }
    document.addEventListener("click", this.closeDropdownActions);
  },
  computed: {
    ...mapGetters("work", ["getWork", "getWorkOperations"]),
    ...mapGetters("simulation", ["getSimulation"]),
    ...mapGetters("document", [
      "getDocuments",
      "getDocumentsTypes",
      "getSelectedDocuments",
      "getDraftDocuments",
      "getDraftDocumentsReplace",
      "getLeavePage",
      "getDocFormInvalid"
    ]),
    ...mapGetters("loader", { loading: "getLoading" }),
    ...mapGetters("account", { userInfo: "getCurrentUser" }),
    noDocToBeCompleted() {
      return some(this.getDocuments.content, { transmitted: false });
    },
    // isToBeCompleted() {
    //   return some(this.getSelectedDocuments, { transmitted: false });
    // },

    classObject() {
      return {
        indeterminateRows:
          this.getTransmittedFiles.length > this.selectedRow.length &&
          this.selectedRow.length >= 1,
        allRows: this.getTransmittedFiles.length == this.selectedRow.length
      };
    },
    classObjectToBeCompleted() {
      return {
        indeterminateRows:
          this.getTobeCompleted.length > this.selectedRowToBeCompleted.length &&
          this.selectedRowToBeCompleted.length >= 1,
        allRows:
          this.getTobeCompleted.length == this.selectedRowToBeCompleted.length
      };
    },
    isInvalid() {
      return (
        this.$v.getDocuments.$invalid ||
        this.getDocFormInvalid ||
        ((!this.getDocuments?.content ||
          this.getDocuments?.content.length === 0) &&
          (!this.getDraftDocuments || this.getDraftDocuments.length === 0))
      );
    },
    getTransmittedFiles() {
      const transmittedFiles = this.getDocuments?.content.filter(
        file => file.transmitted === true
      );
      return transmittedFiles;
    },
    getTobeCompleted() {
      const toBeCompleted = this.getDocuments?.content.filter(
        file => file.transmitted === false
      );
      return toBeCompleted;
    },
    isVIEWER() {
      return helpers.isVIEWER();
    },
    isAutoriseAddDoc() {
      return this.isSimulation
        ? true
        : this.getWorkOperations?.length === 0 ||
            (this.getWorkOperations?.content?.length > 0 &&
              this.getWorkOperations?.content?.some(op =>
                this.allowedStatus.includes(op.status)
              ));
    },
    rows() {
      return this.getDocuments.totalElements || 0;
    }
  },
  watch: {
    getDocuments() {
      if (this.getDocuments?.content.length) {
        this.getDocuments?.content.forEach(doc => {
          const types = [];
          if (doc.types) {
            doc.types.forEach(type => {
              types.push(find(this.getDocumentsTypes, { code: type }));
            });
          }
          if (!this.selectedOperations) {
            this.selectedOperations = new Map();
          }
          if (doc.operations && doc.operations.length > 0) {
            this.selectedOperations.set(doc.id, doc.operations);
          }
          doc.types = types;
        });
      }
    },
    selectedRow(arr) {
      this.allRowsSelected = arr.length !== 0;
    },

    "$v.$invalid": function() {
      if (this.isSimulation) {
        const invalid = this.$v.getDocuments.$invalid;
        eventBus.$emit("invalid-form", invalid);
      }
    },
    getDraftDocuments: function() {
      this.setSimulationChanged(
        this.getDraftDocuments && this.getDraftDocuments.length > 0
      );
    }
  },
  methods: {
    ...mapActions("simulation", [
      "getSimulationOperationsAction",
      "getSimulationAssignOperations"
    ]),
    ...mapActions("notification", ["openModal", "closeModal"]),
    ...mapActions("work", ["getWorkByIdAction", "getAllWorkOperations"]),
    ...mapActions("document", [
      "getDocumentsAction",
      "getDocumentsTypesAction",
      "saveDocumentsAction",
      "deleteDraftDocumentsAction",
      "editDocumentTypesAction",
      "versionsDocumentsAction"
    ]),
    ...mapMutations("document", [
      "setSelectedDocuments",
      "setDraftDocuments",
      "setDocuments",
      "setLeavePage",
      "setDocFormInvalid"
    ]),
    getSimulationOperations() {
      const id = this.$route.params["id"]
        ? parseInt(this.$route.params["id"], 10)
        : this.getSimulation.id;
      if (id) {
        this.getSimulationAssignOperations({
          id: id,
          currentPage: this.currentPage,
          perPage: this.perPage,
          sortBy: this.sortBy,
          sortDir: this.sortDir,
          customFilter: this.customFilter,
          search: this.search
        });
      }
    },
    selectAllRows() {
      if (this.allRowsSelected) {
        this.selectedRow = [];
        const selectedItem = this.getDocuments?.content
          .filter(doc => {
            return doc.transmitted === true;
          })
          .map(doc => {
            var row = {};
            (row["id"] = doc.id), (row["transmitted"] = doc.transmitted);
            if (doc.transmitted) {
              return row["id"];
            }
          });
        this.selectedDocsIds = selectedItem;
        selectedItem.forEach(item => {
          this.selectedRow.push(item);
        });
      } else {
        this.selectedRow = [];
        this.selectedDocsIds = [];
      }
      const docs = [];
      const allDocs = JSON.parse(JSON.stringify(this.getDocuments?.content));
      this.selectedDocsIds.forEach(docId => {
        docs.push(find(allDocs, { id: docId }));
      });
      if (docs && docs.length) {
        this.setSelectedDocuments(docs);
      }
    },
    selectAllRowsToBeCompleted() {
      if (this.allRowsSelectedToBeCompleted) {
        this.selectedRowToBeCompleted = [];
        const selectedRowItem = this.getDocuments?.content
          .filter(doc => {
            return doc.transmitted === false;
          })
          .map(doc => {
            var row = {};
            row["id"] = doc.id;
            row["transmitted"] = doc.transmitted;
            if (!doc.transmitted) {
              return row["id"];
            }
          });
        selectedRowItem.forEach(item => {
          this.selectedRowToBeCompleted.push(item);
        });
        this.selectedDocsIds = selectedRowItem;
      } else {
        this.selectedRowToBeCompleted = [];
        this.selectedDocsIds = [];
      }
      const docs = [];
      const allDocs = JSON.parse(JSON.stringify(this.getDocuments?.content));
      this.selectedDocsIds.forEach(docId => {
        docs.push(find(allDocs, { id: docId }));
      });
      if (docs && docs.length) {
        this.setSelectedDocuments(docs);
      }
    },
    getFileExtention(filename) {
      return filename.split(".").pop();
    },
    getDocExtention(docname) {
      let split = docname.split(".");
      let filename = split[0];
      let extension = split[1];
      if (filename.length > 10) {
        docname = filename.substring(0, 18);
      }
      return docname + "..." + extension;
    },
    getAllDocuments() {
      const id = this.isSimulation
        ? this.getSimulation.id
        : parseInt(this.$route.params["id"], 10);
      if (id) {
        this.getDocumentsAction({
          id: id,
          customFilter: this.customFilter,
          search: this.search,
          myPager: {
            page: this.currentPage > 1 ? this.currentPage - 1 : 0,
            size: this.perPage
          }
        });
      } else {
        this.setDocuments({});
      }
    },
    selectDocument(id) {
      const index = this.selectedDocsIds.indexOf(id);
      if (index > -1) {
        this.selectedDocsIds.splice(index, 1);
      } else {
        this.selectedDocsIds.push(id);
      }
      const docs = [];
      const allDocs = JSON.parse(JSON.stringify(this.getDocuments?.content));
      this.selectedDocsIds.forEach(docId => {
        docs.push(find(allDocs, { id: docId }));
      });
      if (docs && docs.length) {
        this.setSelectedDocuments(docs);
      }
    },
    download() {
      documentService.downloadDocuments(this.selectedDocsIds);
    },
    applyFilter(event) {
      this.selectedDocsIds = [];
      this.customFilter = event.filter.custom;
      this.getAllDocuments();
    },
    applySearch(event) {
      this.search = event.search;
      this.getAllDocuments();
    },
    saveDocuments() {
      this.saveDraftDocuments();
      if (this.getDocuments && this.getDocuments.content.length > 0) {
        const editedDocs = [];
        this.getDocuments.content.forEach(document => {
          const types = document.types;
          let typesCode = Array.isArray(types)
            ? map(types, "code")
            : [types.code];
          editedDocs.push({
            id: document.id,
            types: typesCode,
            operations:
              document.operations?.map(operation => operation.id) || []
          });
        });
        this.editDocumentTypesAction({ documents: editedDocs });
        this.getAllDocuments();
      }
      this.$bvModal.hide("modal-save_changes");
      this.setDocFormInvalid(false);
    },
    discardDocuments() {
      if (this.getDraftDocuments && this.getDraftDocuments.length > 0) {
        const draftDocuments = this.getDraftDocuments;
        this.setDraftDocuments(null);
        this.deleteDraftDocumentsAction({
          documentsName: map(draftDocuments, "fileName"),
          showLoader: false
        });
      }
      this.$bvModal.hide("modal-confirm_leave");
      this.setLeavePage(true);
    },
    saveDraftDocuments() {
      const drafts = this.getDraftDocuments;
      const id = this.isSimulation
        ? this.getSimulation.id
        : parseInt(this.$route.params["id"], 10);
      if (drafts && drafts.length > 0) {
        drafts.forEach(document => {
          this.logsDocumentsMatomo(document, id);
          if (Array.isArray(document.types)) {
            document.types = map(document.types, "code");
          } else {
            document.types = [document.types.code];
          }
          document.operationsId =
            document.operations?.map(operation => operation.id) || [];
        });
        this.setDraftDocuments(null);
        this.saveDocumentsAction({
          id: id,
          customFilter: this.customFilter,
          documentsToUpload: drafts
        });
      }
    },
    logsDocumentsMatomo(document, id) {
      if (window._paq) {
        const action = this.isSimulation
          ? "Document detail simulation"
          : "Document detail ouvrage";
        window._paq.push(
          ["setCustomDimension", 2, action],
          [
            "trackEvent",
            "Documents",
            action,
            this.userInfo.clientName +
              ", " +
              this.userInfo.firstName +
              " " +
              this.userInfo.lastName +
              ", " +
              id +
              " - " +
              document.originalFileName
          ]
        );
      }
    },
    unselectDocs() {
      this.allRowsSelected = false;
      this.selectedDocsIds = [];
      this.allRowsSelectedToBeCompleted = [];
      this.selectedRowToBeCompleted = [];
      this.selectedRow = [];
      this.setSelectedDocuments(null);
    },
    checkDraftDocuments() {
      return this.getDraftDocuments && this.getDraftDocuments.length > 0;
    },
    beforeWindowUnload(e) {
      if (this.checkDraftDocuments()) {
        e.preventDefault();
        e.returnValue = "";
      }
    },
    confirmSave() {
      this.$root.$emit("bv::show::modal", "modal-save_changes");
    },
    toggleMenu(documentName) {
      this.selectedDocumentId =
        this.selectedDocumentId === documentName ? null : documentName;
    },
    assignDocument(docId) {
      const document = this.getDocuments?.content.find(doc => doc.id === docId);
      this.selectedDocumentId = null;
      if (!document.operations) {
        document.operations = [];
      }
      this.selectedDocument = document;
      this.selectedDocument.originalFileName = document.name;
      if (this.selectedOperations.get(this.selectedDocument.id)) {
        this.selectedDocumentOperations = this.selectedOperations.get(
          this.selectedDocument.id
        );
      } else {
        this.selectedDocumentOperations = [];
      }
      this.selectedDocument.operations = this.selectedDocumentOperations;
      this.isMassActions = false;
      this.doOpenAssignDocumentModal();
    },
    doOpenAssignDocumentModal() {
      setTimeout(() => {
        this.openModal({
          instance: this.$root,
          id: "assignDocumentOperationDocuments"
        });
      }, 500);
    },
    downloadFile(docId) {
      documentService.downloadCommonDocument(docId);
    },
    showDocument(docId) {
      const document = this.getDocuments?.content.find(doc => doc.id === docId);
      const fileExtension = this.getFileExtention(document.name);
      const isPdfOrImage = ["pdf", "jpg", "jpeg", "png", "gif", "bmp"].includes(
        fileExtension
      );
      if (isPdfOrImage) {
        documentService.viewCommonDocument(docId);
      } else {
        this.downloadFile(docId);
      }
    },
    doOpenConfirmModal(document) {
      this.deletedDocument = [document];
      setTimeout(() => {
        this.openModal({ instance: this.$root, id: "confirm-delete" });
      }, 1);
    },
    handleSelectedOperations(selectedOperations) {
      this.selectedOperations.set(this.selectedDocument.id, selectedOperations);
      this.selectedDocument.operations = selectedOperations;
    },
    getNbrOperations(docId) {
      const document = this.getDocuments?.content.find(doc => doc.id === docId);
      return document.operations ? document.operations.length : 0;
    },
    showOperation(docId) {
      const document = this.getDocuments?.content.find(doc => doc.id === docId);

      if (this.operationClick === document.id) {
        this.operationClick = null;
      } else {
        this.operationClick = document.id;
      }
      this.selectedDocument = document;
      this.selectedDocument.operations = this.selectedOperations.get(
        document.id
      );
    },
    deleteOperation(operations) {
      this.selectedOperations.set(this.selectedDocument.id, operations);
      this.selectedDocument.operations = operations;
      if (operations.length === 0) {
        this.operationClick = null;
      }
    },
    handleCallDocumentsActions() {
      this.isMassActions = true;
      this.doOpenAssignDocumentModal();
    },
    fetchAllWorkOperations() {
      this.getAllWorkOperations({
        id: parseInt(this.$route.params["id"], 10),
        currentPage: this.currentOperationPage,
        customFilter: this.customOperationFilter,
        perPage: this.perOperationPage,
        sortBy: this.sortBy,
        sortDir: this.sortDir,
        search: this.searchOperation
      });
    },
    isDeletedDocument(docId) {
      return this.isSimulation
        ? true
        : this.selectedOperations
            .get(docId)
            ?.every(op => this.allowedStatus.includes(op.status));
    },
    isReplacedDocument(docId) {
      return (
        !this.selectedOperations.get(docId) ||
        this.selectedOperations
          .get(docId)
          ?.every(op => this.allowedStatus.includes(op.status))
      );
    },
    isUpdatedDocument(docId) {
      return this.isSimulation
        ? true
        : this.getWorkOperations?.length === 0 ||
            (this.getWorkOperations?.content?.length > 0 &&
              this.getWorkOperations?.content?.some(op =>
                this.allowedStatus.includes(op.status)
              ));
    },
    replaceFile(docId) {
      const document = this.getDocuments?.content.find(doc => doc.id === docId);
      if (!document.operations) {
        document.operations = [];
      }
      this.selectedDocument = document;
      this.doOpenDocumentModal("replaceDocumentOperationDocuments");
    },
    doOpenDocumentModal(modalId) {
      setTimeout(() => {
        this.openModal({
          instance: this.$root,
          id: modalId
        });
      }, 500);
    },
    versionFile(docId) {
      this.versionsDocumentsAction({ docId: docId });
      const document = this.getDocuments?.content.find(doc => doc.id === docId);
      if (!document.operations) {
        document.operations = [];
      }
      this.selectedDocument = document;
      this.doOpenDocumentModal("versionsDocument");
    },
    isTypeDocumentSelected(type) {
      return type === null || type.length === 0;
    },
    handleChange(docId) {
      const document = this.getDocuments?.content.find(doc => doc.id === docId);
      document.operations = [];
      if (this.selectedOperations.has(docId)) {
        this.selectedOperations.delete(docId);
      }
    },
    closeDropdownActions(event) {
      if (event.target.closest(".menu-icon")) {
        return;
      }
      if (
        this.selectedDocumentId !== null &&
        !event.target.closest(".dropdown-menu")
      ) {
        this.selectedDocumentId = null;
      }
    },
    changePerPage(perPage) {
      this.currentPage = 1;
      this.perPage = perPage;
      this.getAllDocuments();
    },
    changeCurrentPage(page) {
      this.currentPage = page;
      this.getAllDocuments();
    }
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.beforeWindowUnload);
    document.removeEventListener("click", this.closeDropdownActions);
    eventBus.$off("reloadDocuments");
    eventBus.$off("unselectDocs");
    if (this.isSimulation) {
      eventBus.$emit("save-simulation", {});
    }
  }
};
</script>
<style lang="scss">
.documents-scroll-area {
  max-height: 340px;
}

.menu-container {
  position: relative;
  display: inline-block;
}

.menu-icon {
  cursor: pointer;
  font-size: 24px;
  padding: 8px;
  border-radius: 50%;
  transition: background 0.3s;
}

.menu-icon:hover {
  background: rgba(0, 0, 0, 0.1);
}

.dropdown-menu {
  position: absolute;
  top: 60%;
  left: auto;
  right: 8%;
  background: white;
  border-radius: 5px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  width: 200px;
  z-index: 10;
  display: flex;
  flex-direction: column;
  padding: 5px 0;
}

.dropdown-menu button {
  background: none;
  border: none;
  width: 100%;
  padding: 10px;
  text-align: left;
  cursor: pointer;
  transition: background 0.2s;
}

.dropdown-menu button:hover {
  background: #f0f0f0;
}

.bg-custom {
  background-color: rgba(236, 236, 236, 0.88);
}
.no-pointer-events {
  pointer-events: none;
  cursor: not-allowed;
  color: gray;
}

.multiselect__type {
  width: 100% !important;
}
</style>
